import React from 'react';
import { connect } from 'react-redux'
import { withCookies } from 'react-cookie';
import { AccordionStatus } from './../../constants/actionType';
import { updateSCcustomEvent,tempSCData, updateSCTags} from './../../service/dtmTag';
import {invokeTouchCommerce} from './../../service/aimsChat';
import PromoContent from './../../constants/promoContent';
import { InHomeUtils } from './../../util/inhomeUtils';
import {catchJSException} from './../../service/logService';
import {setAccordionStatus,prefetchPlansForFailedCase,fetchPerksMTM}  from './../../action/buildProduct'
import { tempVzdlSCData,updateVzdlSCCustomEvent , updateDetailValue} from '../../service/vzdl';
import { Title } from '@vds/typography';
import { AccordionTitle } from '@vds/accordions';
import AccordionSubTitleRskn from './accordionSubTitleRskn';
import DowncaretIcon from '@vds/icons/down-caret';
import UpcaretIcon from '@vds/icons/up-caret';
import WifiIcon from '@vds/icons/wifi-wireless';
import GiftIcon from '@vds/icons/gift';
import ServicesIcon from '@vds/icons/services';
import ComplianceIcon from '@vds/icons/compliance-document';
import Phone from '@vds/icons/phone';
import Tv from '@vds/icons/tv';
import Minus from '@vds/icons/minus';
import Plus from '@vds/icons/plus';


class accordionTitleRskn extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state={
      currentInternet : null
    }
}
  handleKeyDown = (e, name, title, omniTitle) => {
    //keyboard accessibility for accordion using space bar and enter keys
    if (e.keyCode === 13 || e.keyCode === 32) {
      this.openAccordion(e, name, title, omniTitle);
    }
  };

  componentDidUpdate(){
    try {
      const cartInternet = this.props.cart?.cartResponse?.tierContent?.[0]?.sections?.section?.find?.(s => s?.sectionName?.toUpperCase?.() === "SERVICE")?.subSections?.subSection?.find?.(s => s?.sectionType?.toUpperCase?.() === "DATASTANDALONE" || s?.sectionType?.toUpperCase?.() === "SVCCOMPONENT")?.products?.find?.(p => p?.prodType === "FTTPD");
      const profileInternet = this.props?.ecProfileCart?.ProfileDataProduct || this.props?.profileCart?.ProfileDataProduct;
      if (cartInternet) {
        this.setState({currentInternet : cartInternet})
      } else if (profileInternet) {
        this.setState({currentInternet : profileInternet})
      } else if (this.currentInternet) {
        this.setState({currentInternet : null})

      }
    } catch (e) {
      console.error(e);
    }
  }
  modifiedTitle=()=>{
    let titleString=(this.props?.title?? "").toString().replace("4.0","").trim();
    return titleString
  }
  getOmniTitle = (omniTitle)=>{
    if (InHomeUtils.isNotNull(omniTitle) && omniTitle !== "") {
      let title = "";
      if (omniTitle === "Please select internet") {
        title = "Add Internet";
      } else if (omniTitle === "Please select router") {
        title = "Add router";
      } else if (omniTitle === "How many TVs") {
        title = "Add settop box ";
      } else if (omniTitle === "Pick your recording service") {
        title = "Add recording service";
      } else if (omniTitle === "Please pick your Live TV option") {
        title = "Add Live TV";
      } else if (omniTitle === "Pick your voice option") {
        title = "Add phone";
      } else if (omniTitle === "Choose your perks") {
        title = "Perks";
      } else if (omniTitle.indexOf("Emergency services") > -1) {
        title = "Emergency Services";
      }else if (omniTitle.indexOf("Streaming device connection bundle") > -1) {
        title = "Use-your-own streaming device";
      } else if (omniTitle.indexOf("Recording service") > -1) {
        title = "Add your recording service"
      }else if (omniTitle.indexOf("International Channels") > -1) {
        title = "add international channels"
      }else if (omniTitle.indexOf("TV connections") > -1 || omniTitle.indexOf("How many TV Connections") > -1) {
        title = "tv customize"
      }else if (omniTitle.indexOf("International calling") > -1) {
        title = "International calling"
      }else if (omniTitle.indexOf("Call more international destinations") > -1) {
        title = "call more international places"
      }else if (omniTitle.indexOf("Phone number") > -1) {
        title = "add your phone number"
      }else if (omniTitle.indexOf("Directory listing") > -1) {
        title = "add to directory listing"
      }else if (omniTitle.indexOf("Inside Wire Maintenance") > -1) {
        title = "Add Internet Security, Protection and More"
      }else if (omniTitle.indexOf("Premium Channels") > -1) {
        title = "Add Premium Channels";
      }
      else {
        title = omniTitle;
      }
      return title;
    }
    return '';
  }
  openAccordion = (e, name, title, omniTitle = "") => {
    try {
      if (InHomeUtils.isNotNull(name)) {
        invokeTouchCommerce(name);
        this.props.dispatch({ type: "SET_MANUAL_ACCORDION_OPEN", value: name });
        setAccordionStatus(name, this.props.dispatch, this.props.isAccordionOpen);
        let isUpsellTagLimit = this.props && this.props.buildProduct && this.props.buildProduct.upsellTagLimitFlag ? true : false;
        if(!isUpsellTagLimit){
        if (!this.props.isAccordionOpen) {
          let val = this.props.isDoFlow ? "do accord" : "byob";
          tempSCData.pageName = val;
          if (name.indexOf("internet") > -1 || name.indexOf("datasub") > -1) {
            // val = val + "| internet"
            val = val + "| internet" + "| " + title;
          } else if (name.indexOf("tv") > -1) {
            val = val + "| tv" + "| " + title;
          } else if (name.indexOf("phone") > -1) {
            if (title === "Call more countries & destinations") {
              title = "call more countries";
            }
            val = val + "| phone" + "| " + title;
          } else if (name.indexOf("perks") > -1) {
            fetchPerksMTM(
              dispatch,
              visitId,
              couponflowType,
              flowType
            );
            val = val + "| perks" + "| " + title;
          } else if (name.indexOf("streamingserv_acc") > -1) {
            val = val + "| stream services-devices";
          } else if (name.indexOf("streamingserv_plan") > -1) {
            val = val + "| stream services-devices| pick service";
          } else if (name.indexOf("streamingdevcnt_plan") > -1) {
            val = val + "| stream services-devices| add devices-nums";
          } else if (name.indexOf("contract") > -1) {
            val = val + "| contract";
          } else if (name.indexOf("internationalchannel") > -1) {
            val = val + "| Add international channel";
          } else if (name.indexOf("flash") > -1) {
            val = val + "| internet| black friday ";
          } else if (name.indexOf("splOffer") > -1) {
            val = val + "| internet| select your int promo offer";
          } else if (name.indexOf("emergency_services") > -1) {
            val = val + "| phone| Emergency Services";
          } else if(name.indexOf('toggle_tv_ceapps_accor') > -1){
            val = val + "Use-your-own streaming device";
          }
          tempSCData.detailPageName = val; // for DOflows/Prepaid need to uodate these values later
          if (InHomeUtils.isNotNull(omniTitle) && omniTitle !== "") {
            let title = "";
            if (omniTitle === "Please select internet") {
              title = "Add Internet";
            } else if (omniTitle === "Please select router") {
              title = "Add router";
            } else if (omniTitle === "How many TVs") {
              title = "Add settop box ";
            } else if (omniTitle === "Pick your recording service") {
              title = "Add recording service";
            } else if (omniTitle === "Please pick your Live TV option") {
              title = "Add Live TV";
            } else if (omniTitle === "Pick your voice option") {
              title = "Add phone";
            } else if (omniTitle === "Choose your perks") {
              title = "Perks";
            } else if (omniTitle.indexOf("Emergency services") > -1) {
              title = "Emergency Services";
            }else if (omniTitle.indexOf("Streaming device connection bundle") > -1) {
              title = "Use-your-own streaming device";
            } else if (omniTitle.indexOf("Recording service") > -1) {
              title = "Add your recording service"
            }else if (omniTitle.indexOf("International Channels") > -1) {
              title = "add international channels"
            }else if (omniTitle.indexOf("TV connections") > -1 || omniTitle.indexOf("How many TV Connections") > -1) {
              title = "tv customize"
            }else if (omniTitle.indexOf("International calling") > -1) {
              title = "International calling"
            }else if (omniTitle.indexOf("Call more international destinations") > -1) {
              title = "call more international places"
            }else if (omniTitle.indexOf("Phone number") > -1) {
              title = "add your phone number"
            }else if (omniTitle.indexOf("Directory listing") > -1) {
              title = "add to directory listing"
            }else if (omniTitle.indexOf("Inside Wire Maintenance") > -1) {
              title = "Add Internet Security, Protection and More"
            }else if (omniTitle.indexOf("Premium Channels") > -1) {
              title = "Add Premium Channels"
            }
            else {
              title = omniTitle;
            }
            tempVzdlSCData.detail = title;
            updateDetailValue(title);
          } else {
            let detailValue="";
            if (
              name.indexOf("internet") > -1 ||
              name.indexOf("tv") > -1 ||
              name.indexOf("phone") > -1 
            ) {
              detailValue =
                val.split("|") && val.split("|").length > 2
                  ? val.split("|")[2].trim()
                  : "";
            } else if (name.indexOf("flash") > -1) {
              detailValue = "internet - black friday";
            }else if (name.indexOf("splOffer") > -1) {
              detailValue = "Choose your offer";
            } else {
              detailValue = val.split("|") && val.split("|").length > 1 ? val.split("|")[1].trim() : "";
            }
            tempVzdlSCData.detail = detailValue;
            updateDetailValue(detailValue);
          }

          let notificationMessage = "";
          const isEmberMnHAuthenticated = this.props?.buildProduct?.internet?.mnhSignupIndicator === "Y" && this.props.buildProduct?.emberInfo?.isEmberFlow;
          
          if(isEmberMnHAuthenticated && name === "toggle_internet_perks_accor" && this.props?.flowType !== "SUPP"){
            const plans = Array.isArray(this.props?.buildProduct?.internet?.m2mPlans) && this.props?.buildProduct?.internet?.m2mPlans?.length > 0
                              ? this.props?.buildProduct?.internet?.m2mPlans: Array.isArray(this.props?.buildProduct?.internet?.twoYearPlans) && this.props?.buildProduct?.internet?.twoYearPlans?.length > 0 ? this.props?.buildProduct?.internet?.twoYearPlans: [];
            const isMax2GigPlan = this.props?.buildProduct?.internet?.m2mPlans?.findIndex?.(item => item?.id === "R3582") > -1;
            const isMax1GigPlan = !isMax2GigPlan && plans?.find?.(item => (item?.id === "R3583" || (item?.name?.toUpperCase?.()?.includes?.("GIG"))));
            const isMax500Plan = !isMax2GigPlan && !isMax1GigPlan && plans?.find?.(item => item?.name?.toUpperCase?.()?.includes?.("500"));
            const hasCartInternet = this.props.cart?.cartResponse?.tierContent?.[0]?.sections?.section?.find?.(s => s?.sectionName?.toUpperCase() === "SERVICE")?.subSections?.subSection?.find?.(s => s?.sectionType?.toUpperCase() === "DATASTANDALONE" || s?.sectionType?.toUpperCase?.() === "SVCCOMPONENT")?.products?.some(p => ((p?.prodName?.toUpperCase?.()?.includes?.("GIG")) || (isMax500Plan && p?.prodName?.toUpperCase?.()?.includes?.("500 MBPS"))));
            const hasCartPerks = this.props?.cart?.cartResponse?.tierContent?.[0]?.sections?.section?.find((item) => item?.sectionName?.toUpperCase() === "PERKS")?.subSections?.subSection?.find((item) => item?.sectionType?.toUpperCase() === "PERKS")?.products?.length > 0;
            const hasPerkCredit = this.props?.buildProduct?.internet?.m2mPlans?.some?.((prodId) => this.state.currentInternet?.prodId === prodId?.id && prodId?.specialOffers?.some?.((obj) => obj?.OfferText?.toUpperCase?.()?.includes?.("HOME PERK CREDIT")));
            const wirelessPerks = this.props?.buildProduct?.perkMessages?.filter((list) => list?.msgId?.includes('WIRELESS'))?.map(perk => perk?.applicablePerks);  
            const isMaxGigabitPlan = plans?.find?.(item => !isMax2GigPlan && item?.name?.toUpperCase?.()?.includes?.("GIGABIT CONNECTION"));
            let plan = isMax2GigPlan ? "1 Gig/2 Gig": isMaxGigabitPlan ? isMaxGigabitPlan?.name || "Gigabit Connection" : isMax1GigPlan ? isMax1GigPlan?.name || "1 Gig" : isMax500Plan ? isMax500Plan?.name || "500 Mbps" : "";
            plan = plan?.replace?.("4.0", "")?.trim?.();
            if((!hasCartPerks && !hasCartInternet) && (this.props?.buildProduct?.internet?.selectedProduct === null || this.props?.buildProduct?.internet?.selectedProduct?.name?.includes('300') || this.props?.buildProduct?.internet?.selectedProduct?.name?.includes('500'))){
              notificationMessage = notificationMessage + `Get a perk, on us. Upgrade your plan to ${plan} to get up to dollar 10/mo towards an eligible perk`;
            }
            else if((!hasCartPerks && hasCartInternet)  && wirelessPerks?.length===0){
              notificationMessage = notificationMessage + `Claim your perk on us. Because you selected ${this.state.currentInternet?.prodName}, you have up to dollar 10/mo credit towards an eligible perk. Credit will be reflected in your cart.`;
            }
            else if((hasPerkCredit && hasCartInternet) && wirelessPerks?.length > 0 ){
              notificationMessage = notificationMessage + "You qualify for a perk, on us up to dollar 10/mo. The credit will be applied to an eligible perk you add here or an existing perk on your account in 1-2 billing cycles, if applicable.";
            }
          } 
          if (this.props.flowType === "MV") {
            let updateTags = notificationMessage === "" ? "detail" : "notification,detail";
            let delayDuration = notificationMessage === "" ? 0 : 1000;
            if (
              this.props.cust_opt === "NONSEAMLESS" &&
              this.props.isFCPflow &&
              !this.props.isFcpInProfile
            ) {
              tempSCData.flowName = "prospect accord move| mix match";
              tempVzdlSCData.flowName = "accord move + mix match";
            } else if (
              this.props.cust_opt === "SEAMLESS" &&
              this.props.isFCPflow &&
              !this.props.isFcpInProfile
            ) {
              tempSCData.flowName = "prospect accord seamless move";
              tempVzdlSCData.flowName = "prospect accord + seamless move";
            } else if (
              this.props.cust_opt === "SEAMLESS" &&
              this.props.isFCPflow &&
              this.props.isFcpInProfile
            ) {
              tempSCData.flowName = "prospect accord seamless move| mix match";
              tempVzdlSCData.flowName = "accord seamless move + mix match";
            } else if (
              this.props.isFCPflow &&
              this.props.cust_opt == null &&
              this.props.isFcpInProfile
            ) {
              tempSCData.flowName = "prospect accord move| mix match";
              tempVzdlSCData.flowName = "accord move + mix match";
            } else {
              tempSCData.flowName = "prospect accord move";
              tempVzdlSCData.flowName = "accord move";
            }
            tempSCData.customerCategory = "^Moves^";
            updateSCcustomEvent(
              "accordionOpenMoves",
              "ddAddToCartEvent",
              "detailPageName,pageName"
            );
            let tempDetailValue = tempVzdlSCData.detail;
            setTimeout(() => { 
            tempVzdlSCData.detail = tempDetailValue;
            updateVzdlSCCustomEvent(
              "accordionOpenMoves",
              "pageViewOmni",
              updateTags,
              false, "", false,
              notificationMessage
            );
            }, delayDuration)
          } else {
            if (this.props.flowType === "SUPP") {
              tempSCData.contentChannel =
                "/vz/residential/myverizon/whats+next/fios/acrd supp order";
              updateSCcustomEvent(
                "accordionOpen",
                "ddAddToCartEvent",
                "detailPageName,pageName,contentChannel"
              );
              updateVzdlSCCustomEvent(
                "accordionOpen",
                "pageViewOmni",
                "detail"
              );
            } else {            
              let selectedCurrProduct = "";
              if(this.props?.lqState?.hoaFlowDetails?.isHoaFlow && this.props?.buildProduct?.hoabundle && InHomeUtils.isNotNull(this.props.buildProduct.hoabundle.hoaresponse) && InHomeUtils.isNotNull(this.props.buildProduct.hoabundle.hoaresponse.defaultMap)){
                notificationMessage = "As a Verizon Enhanced Communities Value Program customer, your offer includes ";
                if(name === "toggle_internet_plan_accor" && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.internet && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.internet != ""){
                  notificationMessage = notificationMessage + this.props.buildProduct.hoabundle.hoaresponse.defaultMap.internet;
                }
                else if(name === "toggle_tv_plan_accor" && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.video && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.video != ""){
                  notificationMessage = notificationMessage + this.props.buildProduct.hoabundle.hoaresponse.defaultMap.video;
                }
                else if(name === "toggle_tv_settopbox_accor" && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.vRoom && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.vRoom != ""){
                  notificationMessage = notificationMessage + this.props.buildProduct.hoabundle.hoaresponse.defaultMap.vRoom;
                }
                else if(name === "toggle_tv_channel_accor" && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.channel && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.channel != ""){
                  notificationMessage = notificationMessage + this.props.buildProduct.hoabundle.hoaresponse.defaultMap.channel;
                }
                else if(name === "toggle_phone_plan_accor" && this.props.lqState &&  this.props.lqState.hoaFlowDetails && this.props.lqState.hoaFlowDetails.isHoaFlow && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.voice != undefined && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.voice !=""){
                  notificationMessage = notificationMessage + this.props.buildProduct.hoabundle.hoaresponse.defaultMap.voice;
                  selectedCurrProduct = InHomeUtils.isNotNull(this.props.buildProduct?.voice?.selectedProduct) ? this.props.buildProduct.voice.selectedProduct : "";
                }
                else if(name === "toggle_phone_accor"  && this.props.lqState &&  this.props.lqState.hoaFlowDetails && this.props.lqState.hoaFlowDetails.isHoaFlow && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.voice != undefined && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.voice !=""){
                  if(this.props.buildProduct.voice && this.props.buildProduct.voice.isSubAccordionOpen){
                    notificationMessage = notificationMessage + this.props.buildProduct.hoabundle.hoaresponse.defaultMap.voice;
                    selectedCurrProduct = InHomeUtils.isNotNull(this.props.buildProduct.voice?.selectedProduct) ? this.props.buildProduct.voice.selectedProduct : "";
                  }
                  else{
                    notificationMessage = "";
                  }
                }  
                else if(name === "toggle_internet_accor"){
                  if(this.props.buildProduct.internet && this.props.buildProduct.internet.isSubAccordionOpen && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.internet && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.internet != ""){
                    notificationMessage = notificationMessage + this.props.buildProduct.hoabundle.hoaresponse.defaultMap.internet;
                  }
                  else{
                    notificationMessage = "";
                  }
                }
                else if(name === "toggle_tv_accor"){
                  if(this.props.buildProduct.tv && this.props.buildProduct.tv.isSubAccordionOpen && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.video && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.video != ""){
                    notificationMessage = notificationMessage + this.props.buildProduct.hoabundle.hoaresponse.defaultMap.video;
                  }
                  else if(this.props.buildProduct.vRoom && this.props.buildProduct.vRoom.isAccordionOpen && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.vRoom && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.vRoom != "" ){
                    notificationMessage = notificationMessage + this.props.buildProduct.hoabundle.hoaresponse.defaultMap.vRoom;
                  }
                  else if(this.props.buildProduct.channel && this.props.buildProduct.channel.isAccordionOpen && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.channel && this.props.buildProduct.hoabundle.hoaresponse.defaultMap.channel != ""){
                    notificationMessage = notificationMessage + this.props.buildProduct.hoabundle.hoaresponse.defaultMap.channel;
                  }
                  else{
                    notificationMessage = "";
                  }
                }
                else{
                  notificationMessage = "";
                }
              }
              let updateTags = notificationMessage === "" ? "detail" : "notification,detail";
              let delayDuration = notificationMessage === "" ? 0 : 1000;
              let contentFragment='';
              if(name === 'toggle_internet_plan_accor' || name === 'toggle_internet_accor'){
                if( InHomeUtils.isNotNull(this.props.buildProduct?.internet.m2mPlans) && this.props.buildProduct?.internet.m2mPlans.length > 0){
                  this.props.buildProduct?.internet.m2mPlans.map((prod,index)=>{
                     contentFragment += `L1|P${index+1}|Internet|${prod.name}|||`
                     prod?.specialOffers.map((offer,i)=>{
                        if(!['Q7734', 'R3885','R3884','R4050','R4048','P0256','R3883','R4262'].includes(offer?.id))
                             contentFragment += `${offer.OfferText}_`
                        }) 
                        contentFragment=contentFragment.slice(0,-1)+"^"
                }) 
              }
            }
              else if(name === "toggle_tv_plan_accor" || name === "toggle_tv_accor"){
                 if( InHomeUtils.isNotNull(this.props.buildProduct.tv.m2mPlans) && this.props.buildProduct.tv.m2mPlans.length > 0){
                  this.props.buildProduct.tv.m2mPlans.map((prod,index)=>{
                      if( ['R3574','R3575'].includes(prod.id)) {
                          contentFragment += `L4|P${prod.id==='R3574'?'2':'3'}|Tv|${prod.name}||||`;
                          prod?.specialOffers.map((offer,i)=>{
                              if(!['R1942','P0257'].includes(offer?.id)) 
                                  contentFragment += `${offer.OfferText.replace('(TV)','')}_`
                         })
                         contentFragment=contentFragment.slice(0,-1)+"^"
                      }
                  })  
                  } 
              }
              updateSCcustomEvent(
                "accordionOpen",
                "ddAddToCartEvent",
                "detailPageName,pageName"
              );
              let tempDetailValue = tempVzdlSCData.detail;
              setTimeout(() => { 
                tempVzdlSCData.detail = tempDetailValue;
                updateVzdlSCCustomEvent(
                  "accordionOpen",
                  "pageViewOmni",
                  updateTags,
                  false, "", false,
                  notificationMessage,selectedCurrProduct,"","",this.props?.buildProduct,contentFragment.slice(0, -1)
                );
              }, delayDuration);
            }
          }
          if(name === 'toggle_internet_accor'){
            updateSCTags(`${title}:expanded`);
          }
          else if(name === 'toggle_tv_accor'){
            updateSCTags('add live tv:expanded');
          }else if(name === 'toggle_internet_perks_accor'){
            updateSCTags('perks:expanded');
          }else if(name === 'toggle_internet_plan_accor'){
            updateSCTags('internet speed:expanded');
          }else if(name === 'toggle_internet_router_accor'){
            updateSCTags('internet equipment:expanded');
          }else if(name === 'toggle_data_splOffer_accor'){
            updateSCTags('Choose your offer:expanded');
          }else if(name === 'toggle_phone_backup_accor'){
            updateSCTags('PowerReserve:expanded');
          }else if(name === "toggle_tv_plan_accor"){
            updateSCTags('Tv Plan: expanded');
          }
          else{
            updateSCTags(`${omniTitle ? omniTitle : title}:expanded`, '',this.getOmniTitle(omniTitle));
          }
        }
        else {
          if(name === 'toggle_internet_accor'){
            updateSCTags(`${title}:collapsed`);
          }
          else if(name === 'toggle_tv_accor'){
            updateSCTags('add live tv:collapsed', '', this.getOmniTitle(omniTitle));
          }else if(name === 'toggle_internet_perks_accor'){
            updateSCTags('perks:collapsed');
          }else if(name === 'toggle_internet_plan_accor'){
            updateSCTags('internet speed:collapsed');
          }else if(name === 'toggle_internet_router_accor'){
            updateSCTags('internet equipment:collapsed');
          }else if(name === 'toggle_data_splOffer_accor'){
            updateSCTags('Choose your offer:collapsed');
          }else if(name === 'toggle_phone_backup_accor'){
            updateSCTags('PowerReserve:collapsed', '', this.getOmniTitle(omniTitle));
          }
          else if(name === "toggle_tv_plan_accor"){
            updateSCTags('Tv Plan: collapsed', '', this.getOmniTitle(omniTitle));
          }
          else {
            updateSCTags(`${omniTitle ? omniTitle : title}:collapsed`, '', this.getOmniTitle(omniTitle));
          }
        }
        }
        this.checkProductsForLBO(name);
      }
    } catch (ex) {
      catchJSException(
        "BuildProduct",
        this.props.visitId,
        "accordionTitle-openAccordion",
        ex
      );
    }
  };

  checkProductsForLBO = (accName) => {
    let addlParam = {
      zip: this.props.zip,
      tarCode: this.props.tarcode,
      channelLineUpTvPackages: this.props.buildProduct.masterpackageview,
      isDoflow: false,
      couponFlowType: null,
      flowType: "",
      reAttemptCount: 2,
    };
    let suppHasSlingTV = this.props.suppHasSlingTV;
    if (
      accName.toLowerCase().indexOf("internet_accor") > -1 &&
      !this.props.buildProduct.internet.isAccordionOpen &&
      this.props.buildProduct.internet.isSubAccordionOpen &&
      this.props.buildProduct.internet.m2mPlans.length === 0
    ) {
      prefetchPlansForFailedCase(
        this.props.dispatch,
        this.props.visitId,
        addlParam,
        "data"
      );
    } else if (
      !InHomeUtils.isNotNull(suppHasSlingTV) &&
      accName.toLowerCase().indexOf("tv_accor") > -1 &&
      !this.props.buildProduct.tv.isAccordionOpen &&
      this.props.buildProduct.tv.isSubAccordionOpen &&
      this.props.buildProduct.tv.m2mPlans.length === 0
    ) {
      prefetchPlansForFailedCase(
        this.props.dispatch,
        this.props.visitId,
        addlParam,
        "video"
      );
    } else if (
      accName.toLowerCase().indexOf("phone_accor") > -1 &&
      !this.props.buildProduct.voice.isAccordionOpen &&
      this.props.buildProduct.voice.isSubAccordionOpen &&
      this.props.buildProduct.voice.plans.length === 0
    ) {
      prefetchPlansForFailedCase(
        this.props.dispatch,
        this.props.visitId,
        addlParam,
        "voice"
      );
    }
  };

  getAccIcon = () => {
    switch(this.props.name) {
      case 'toggle_internet_accor': 
      return (<WifiIcon 
            size="large" ariaHidden="true"
            />);
      case 'toggle_tv_accor': 
      return (<Tv 
        size="large" ariaHidden="true"
        />);
      case 'toggle_phone_accor': 
      return (<Phone 
        size="large" ariaHidden="true"
        />);
      case 'toggle_contract_accor': 
      return (<ComplianceIcon 
        size="large" ariaHidden="true"
        />);
      case 'toggle_splOffer_accor': 
      return (<GiftIcon 
        size="large" ariaHidden="true"
        />);
      case 'toggle_internet_perks_accor':
        return (<ServicesIcon 
          size="large" ariaHidden="true"
          />);  
      default: 
        return(<></>);
    }
  };

  mainTitle(props) {
    let title = "";
    if (props.name == "toggle_phone_plan_accor" && props.status == "added") {
      return (title = "Phone Plan");
    } else if (
      (props.name == "toggle_phone_intlcalling_accor" ||
        props.name == "toggle_phone_winbackcheck_accor" ||
        props.name == "toggle_phone_listing_accor" ||
        props.name == "toggle_phone_backup_accor") &&
      props.status == "added"
    ) {
      return (title = props.titleOmniName);
    } else if (
      props.name == "toggle_phone_intlplans_accor" &&
      props.status == "added"
    ) {
      return (title = "Call more international destinations");
    }
  }

  subTitleReqText(props) {
    let subText = "";
    let SelectedprodName="";
    if (props.name == "toggle_phone_intlcalling_accor") {
      return (subText = "- Choose your international calling destination.");
    } else if (props.name == "toggle_phone_backup_accor") {
      return (subText =
        "- Get a backup battery-powered device for phone service.");
    } else if (props.name == "toggle_phone_listing_accor") {
      return (subText = "- List your number in a directory. ");
    } else if (props.name == "toggle_phone_winbackcheck_accor") {
      return (subText =
        "- Use your current phone number with your new service or get a new one.");
    } else if (props.name == "toggle_emergency_services_accor") {
      return (subText = "- Use this line to support a fire alarm.");
    } else if(props.name === 'toggle_data_splOffer_accor') {
      return subText = '- Choose one gift, included with your plan.';
    }
    //Added selectedProduct name, if exists for the parent internet,tv and phone accordions
    else if (props.name == "toggle_internet_accor" || props.name == "toggle_internet_plan_accor") {
      let SelectedprodName=this.props?.buildProduct?.internet?.selectedProduct?.name?? "";
      SelectedprodName=SelectedprodName.replace("4.0","").trim();
      return SelectedprodName
    }else if (props.name == "toggle_tv_accor" || props.name == "toggle_tv_plan_accor") {
      SelectedprodName=this.props?.buildProduct?.tv?.selectedProduct?.name?? "";
      SelectedprodName=(SelectedprodName.replace("4.0","")).trim();
     return SelectedprodName;
    }
    else if (props.name == "toggle_phone_accor" || props.name == "toggle_phone_plan_accor") {
      SelectedprodName=this.props?.buildProduct?.voice?.selectedProduct?.name?? "";
      SelectedprodName=(SelectedprodName.replace("4.0","")).trim();
      return SelectedprodName;
    }
    else{
      return  (subText ="")
    }
  }

  AccTitleaddText(props){
    let subText = "";
    let perkscnt = 0;

    if(props.name == "toggle_internet_accor"){
       subText = props.buildProduct?.internet?.selectedProduct?.name;
      perkscnt = (props.buildProduct.perks.selectedProduct != null)
        ? props.buildProduct?.perks?.selectedProduct?.length
        : Array.isArray(props?.cart?.cartData[0]?.perks?.perks)
          ? props.cart.cartData[0].perks.perks.length
          : 0;
      return subText?.toString().replace('4.0', '').replaceAll("&reg;", "\u00AE") + (perkscnt > 0 ? ' & ' + perkscnt + (perkscnt == '1' ? ' perk added':' perks added') : "");
    } else if(props.name == "toggle_tv_accor") {
      const selectedProd = props?.buildProduct?.tv?.selectedProduct?.name || '';
      const selectedProdSubText = selectedProd?.toString().replace('4.0', '').replaceAll("&reg;", "\u00AE");

      return `${selectedProdSubText ? `${selectedProdSubText}` : ''}`;
    } else if(props.name == "toggle_phone_accor") {
      const selectedProd = props?.buildProduct?.voice?.selectedProduct?.name || '';
      const selectedProdSubText = selectedProd?.toString().replace('4.0', '').replaceAll("&reg;", "\u00AE") || '';

      if (selectedProdSubText.toLowerCase().trim() === 'home phone') {
        return `Fios ${selectedProdSubText}`
      } else {
        return selectedProdSubText;
      }
    } else {
      return 'Added';
    }
  }

  subTitleOptText(props) {
    let subText = "";
    if (
      props.name == "toggle_phone_intlplans_accor" &&
      props.status == "optional"
    ) {
      return (subText = "Optional - Choose Verizon World Plan.");
    } else if (
      props.name == "toggle_emergency_services_accor" &&
      props.status == "optional"
    ) {
      return (subText = "Optional - Use this line to support a fire alarm.");
    } else if (props.name == "toggle_internet_techsure_accor") {
      return (subText = "Optional - Choose your option.");
    } 
    else if (props.name == "toggle_phone_accor" && props?.Voicesubtitle) {
      return (subText = props?.Voicesubtitle);
    } 
  }

  subTitleOptTextTV(props) {
    let subText = "";
    if(props.name == 'toggle_internet_perks_accor'){
      return (subText = (this.props.buildProduct.isMonarchView && !this.props?.buildProduct?.internet?.selectedProduct) ? 'Optional - Please select internet plan first.' : "Optional - Choose your perks.");
    } else if(props.name == 'toggle_tv_internationalchannel_accor'){
      return (subText = "Optional - Choose your international channels.");
    } else if(props.name == 'toggle_tv_channel_accor'){
      return (subText = "Optional - Choose your favorite premium channels.");
    } else if(props.name == 'toggle_tv_ceapps_accor'){
      return (subText = "Optional - Choose your streaming device.");
    }
  }

  subTitleaddText(props) {
  
    let subText = "";
    if (
      (props.name == "toggle_phone_intlplans_accor" ||
        props.name == "toggle_phone_backup_accor" ||
        props.name == "toggle_phone_listing_accor" ||
        props.name == "toggle_phone_winbackcheck_accor") &&
      props.status == "added"
    ) {
      return (subText = props.title[0]);
    } else if (
      props.name == "toggle_phone_intlcalling_accor" &&
      props.status == "added"
    ) {
      return (subText = "Included - " + props.selectedProduct.countryName);
    } else if(props.name == "toggle_tv_plan_accor"){
      return (subText = "Choose Live TV");
    } else if(props.name == "toggle_phone_plan_accor" && props.status == "added"){
      return (subText = 'Fios Home Phone');
    } else if(props.name == "toggle_internet_plan_accor"){
      return (subText = 'Choose your internet speed option');
    }
  }

  getSubTitleReqString = () => {
    if(this.props.buildProduct.isMNEnabled && this.props.name !== 'toggle_internet_router_accor') {
      if(this.props.name !== "toggle_tv_router_accor") {
        return 'Required';
      } else {
        return 'Choose your router';
      }
    } else {
      if(this.props.name === 'toggle_tv_settopbox_accor' || this.props.name === 'toggle_tv_recording_accor') {
        return 'Required';
      } else {
        return 'Included with your plan';
      }
    }
  }
  checkIfHoaFlow = () => {
    return this.props.lqState && this.props.lqState.hoaFlowDetails && this.props.lqState.hoaFlowDetails.isHoaFlow;
  }

  getDataAccTitleOnSelection = () => {
    let title = this.props.selectedProduct?.name?.replace('4.0', '')?.replaceAll("&reg;", "\u00AE");
    let offer = this.props?.buildProduct?.sploffer?.data?.selectedProduct?.OfferText;
    if(this.props.buildProduct?.router?.selectedProduct?.accordionTitle) {
      title += `, ${this.props?.buildProduct?.router?.selectedProduct?.accordionTitle}`;
    }
    if(offer) {
      if(offer?.toLowerCase()?.includes('fios gaming')) {
        offer = offer?.replace('Fios', 'Xbox');
      }
      title += `, ${offer}`;
    }
    return title;
  }
  getAccordionIcon = (iconName, iconSize) =>{
    switch(iconName) {
      case 'up-caret': 
      return (<UpcaretIcon 
        size={iconSize} color="#000" ariaHidden="true"
            />);
      case 'down-caret': 
      return (<DowncaretIcon 
        size={iconSize} color="#000" ariaHidden="true"
        />);
      case 'minus': 
      return (<Minus 
        size={iconSize} color="#000" ariaHidden="true"
        />);
        case 'plus': 
      return (<Plus 
        size={iconSize} color="#000" ariaHidden="true"
        />);
    }
  }

  render() {
    let streamLinePhoneTvVoice = window && window.location && window.location.pathname && window.location.pathname.includes('streamlinetvvoice')
    let streamlineSplOffer = window && window.location && window.location.pathname && window.location.pathname.includes('streamlineordering')
    let isVECClass = this.checkIfHoaFlow()? 'setBgRouterAccor' : '';
    // console.log('!!!!!!!!!!!!!!!!!!!!!!!!!',this.props)
    let actionStatus = "",
    headerStatusClass = "required_ribbon normal-weight";
    let pathName=window.location.pathname
    let mm3Qualified = this.props.buildProduct.internet.mm3Qualified;
    const isClassicFlow = !this.props.buildProduct.mnFromApi;
    const isMobile = window.screen.width < 768 ;
    const isTabletMini = (window.screen.width === 768)
    const accordIconOpenedName = (this.props.flowType === "MV" || this.props.flowType === "SUPP"|| isClassicFlow ) ? "up-caret" : "minus"
    const accordIconClosedName = (this.props.flowType === "MV" || this.props.flowType === "SUPP" || isClassicFlow ) ? "down-caret" : "plus"
    const isMainServiceAccordion = ["toggle_internet_accor", "toggle_tv_accor", "toggle_phone_accor"]?.includes(this.props?.name);
    const iconSize = isMainServiceAccordion ? isMobile ? "large" : "XLarge" : isMobile ? "medium" : "large" 
    if (this.props.status === AccordionStatus.required) {
      actionStatus = (
        <span className={` ${pathName==="/inhome/streamlineordering" || window.location.pathname==="/inhome/streamlinetvvoice" ? 'm_requiredStreamLine' : 'm_required'}  ${isVECClass} ${this.props.buildProduct.isMonarchView ? 'm_added_reskin_monarch' : 'm_added_reskin'}`}>
          {/* <Title viewport="mobile"  primitive="span" color="#cd040b">
          Required
        </Title> */}
          {this.props.isAccordionOpen && (
            // <Icon name={accordIconOpenedName}  color="#000" size={iconSize} ariaHidden="true" />
            this.getAccordionIcon(accordIconOpenedName,iconSize)
          )}
          {!this.props.isAccordionOpen && (
            this.getAccordionIcon(accordIconClosedName,iconSize)
            // <Icon
            //   name={accordIconClosedName}
            //   color="#000"
            //   size={iconSize}
            //   ariaHidden="true"
            // />
          )}
        </span>
      );
      headerStatusClass = "required_ribbon normal-weight required";
    } else if (this.props.isAccordionOpen) {
      headerStatusClass = "required_ribbon normal-weight added";
      actionStatus = (
        <span className={`m_added ${isVECClass} ${this.props.buildProduct.isMonarchView ? 'm_added_reskin_monarch' : 'm_added_reskin'}`}>
          {/* <Title viewport="mobile"  primitive="span" color="#00AD3E">
          Added
        </Title> */}
        {this.getAccordionIcon(accordIconOpenedName,iconSize)}
          {/* <Icon name={accordIconOpenedName} color="#000" size={iconSize} ariaHidden="true" /> */}
        </span>
      );
    } else if (!this.props.isAccordionOpen) {
      headerStatusClass = "required_ribbon normal-weight added";
      actionStatus = (
        <span className={`m_added ${isVECClass} ${this.props.buildProduct.isMonarchView ? 'm_added_reskin_monarch' : 'm_added_reskin'}`}>
          {/* <Title viewport="mobile"  primitive="span" color="#00AD3E">
          Added
        </Title> */}
        {this.getAccordionIcon(accordIconClosedName,iconSize)}
          {/* <Icon name={accordIconClosedName} ariaHidden="true" color="#000" size={iconSize} /> */}
        </span>
      );
    } else if (this.props.status === AccordionStatus.completed) {
      headerStatusClass =
        "required_ribbon normal-weight headingstatuscompleted";
      actionStatus = (
        <span className="m_headingadded">
          <Title viewport="mobile" primitive="span" color="#00AD3E">
            Added
          </Title>
        </span>
      );
    } else if (this.props.status === AccordionStatus.actionRequired) {
      actionStatus = (
        <span className="m_actionrequired">
          <Title viewport="mobile" primitive="span" color="#ed7000">
            Action Required
          </Title>
        </span>
      );
      headerStatusClass = "required_ribbon normal-weight headingstatusrequired";
    } else if (this.props.status === AccordionStatus.reviewRequired) {
      actionStatus = (
        <span className="m_reviewrequired">
          <Title viewport="mobile" primitive="span" color="#ed7000">
            Review Required
          </Title>
        </span>
      );
    } else if (this.props.status === AccordionStatus.optional) {
      actionStatus = (
        <span className="t_optional">
          <Title viewport="mobile" primitive="span" color="#747676">
            Optional
          </Title>
        </span>
      );
      headerStatusClass = "required_ribbon normal-weight headingoptional";
    } else {
      headerStatusClass = "required_ribbon normal-weight added";
      actionStatus = (
        <span className={`m_added ${isVECClass} ${this.props.buildProduct.isMonarchView ? 'm_added_reskin_monarch' : 'm_added_reskin'}`}>
          {/* <Title viewport="mobile"  primitive="span" color="#00AD3E">
          Added
        </Title> */}
          <UpcaretIcon color="#000" size="large" />
        </span>
      );
    }

    let promoInfo = "";
    let isHidePromo = false;
    if (
      InHomeUtils.isNotNull(this.props.isHidePromo) &&
      this.props.isHidePromo === "true"
    ) {
      isHidePromo = true;
    }
    if (!isHidePromo) {
      let isCartData =
        InHomeUtils.isNotNull(this.props.cart) &&
        InHomeUtils.isNotNull(this.props.cart.cartData) &&
        this.props.cart.cartData.length > 0
          ? true
          : false;

      if (
        isCartData &&
        InHomeUtils.isNotNull(this.props.locationId) &&
        this.props.locationId !== ""
      ) {
        promoInfo = (
          <PromoContent
            locationId={this.props.locationId}
            cartData={this.props.cart.cartData[0]}
            buildProductContent={this.props.buildProduct}
          />
        );
      }
    }
    
    let isProgressBarPresent =
      this.props?.lqState?.runtimeKey?.displayProgressBar === "Y" &&
      window.showProgressBar === "Y" &&
      this.props.buildProduct.isProgressBarDisplayed
        ? true
        : false;
    let isReskin =
      this.props.buildProduct.isReskin &&
      this.props.lqState &&
      this.props.lqState.runtimeKey &&
      this.props.lqState.runtimeKey.EnableReskin === "Y";
    const accordionTitleName =
      this.props.title &&
      this.props.title[0] &&
      this.props.title[0].indexOf("Fios TV Connection") > -1
        ? this.props.buildProduct.vRoom.unitCount > 1
          ? this.props.title[0].replace("Fios TV Connections", "Set-top boxes")
          : this.props.title[0].replace("Fios TV Connection", "Set-top box")
        : (this.props.name === "toggle_phone_plan_accor" &&
            this.props.status == "added") ||
          (this.props.name === "toggle_phone_intlcalling_accor" &&
            this.props.status == "added") ||
          (this.props.name === "toggle_phone_intlplans_accor" &&
            this.props.status == "added") ||
          (this.props.name === "toggle_phone_winbackcheck_accor" &&
            this.props.status == "added") ||
          (this.props.name === "toggle_phone_listing_accor" &&
            this.props.status == "added") ||
          (this.props.name === "toggle_phone_backup_accor" &&
            this.props.status == "added")
        ? this.mainTitle(this.props)
        : (this.props?.name === "toggle_phone_plan_accor" && this.props?.status == "") ? "Pick your voice option" :this.props?.title?.toString()?.indexOf?.("Fios Gaming Bundle, on us") !== -1 ? this.props?.title?.toString()?.replace?.("Fios Gaming Bundle, on us","Xbox Gaming Bundle, on us") : ( this.props?.name === "toggle_internet_plan_accor" ? "Internet Speed" : this?.props?.title);

    let accordionName = (accordionTitleName || '')?.toString().replace('4.0', '').replaceAll("&reg;", "\u00AE").replace('Choose','') || '';
    let accordionTitle = '';
    if (accordionName.toLowerCase().trim() === 'home phone') {
      accordionTitle = `Phone`;
    // https://onejira.verizon.com/browse/PRODDEF-38439
    // Header should be static as "Router", and Subtitle should change to whatever is selected...Router Only, Use Your Own Router, or Buy: Verizon Router.
    } else if (this.props?.name === 'toggle_tv_router_accor' && !this.props?.isAccordionOpen && this.props?.buildProduct?.router?.selectedProduct && this.props?.buildProduct?.router?.selectedProduct !== null) {
      accordionTitle = `Router`;
    } else if (this.props?.name === 'toggle_internet_perks_accor') {
      accordionTitle = "Perks";
    } else {
      accordionTitle = accordionName;
    }
    
    let isClassicOrMM3Flow = !mm3Qualified ? "classicFlow " : "mm3Flow ";
    let accRevealClass = this.props.buildProduct?.isMonarchView ? 'accordion_blocks-reveal_monarch' : 'accordion_blocks-reveal';
    let tilebutton=this.checkIfHoaFlow()?'accord-acc-wrapper pointer accordionWrapperRskn margin-o':`accord-acc-wrapper pointer accordionWrapperRskn ${isTabletMini && "tabletMiniAccordionWrapper"}`;
    
    let template = (
      <div
        id={this.props.name}
        ref={(e) => (this.props.inputelementRef[this.props.name] = e)}
        onKeyDown={(e) =>
          this.handleKeyDown(
            e,
            this.props.name,
            this.props.title,
            this.props.titleOmniName
          )
        }
        onClick={(e) =>
          this.openAccordion(
            e,
            this.props.name,
            this.props.title,
            this.props.titleOmniName
          )
        }
        className={
          this.props.name != "toggle_internet_accor" &&
          this.props.name != "toggle_tv_accor" &&
          this.props.name != "toggle_phone_accor"
            ? this.props.isAccordionOpenRequired === false
              ? `${accRevealClass} accordion_blocks-revealRskn ${isVECClass} ${isClassicOrMM3Flow}`
              : this.props.isAccordionOpen
              ? `${accRevealClass} accordion_blocks-revealRskn ${isVECClass} accordionWrapperReskin open ${isClassicOrMM3Flow}`
              : `${accRevealClass} accordion_blocks-revealRskn ${isVECClass} accordionWrapperReskin close ${isClassicOrMM3Flow}`
            : this.props.isAccordionOpenRequired === false
            ? `${accRevealClass} HeadRskn`
            : this.props.isAccordionOpen
            ? `${accRevealClass} accordion_blocks-revealRskn ${isVECClass} open HeadRskn ${isClassicOrMM3Flow}`
            : `${accRevealClass} accordion_blocks-revealRskn ${isVECClass} close HeadRskn ${isClassicOrMM3Flow}`
        }
        data-reveal-toggle-class="close open"
        data-internet-options=""
        data-reveal-group="OrderingAccordion"
        style={{
          borderTop: isProgressBarPresent && !isReskin && "1.5px solid black",
          paddingTop: this.props.name === "toggle_internet_router_accor" && !isTabletMini && !window.location.pathname ==="/inhome/streamlineordering" ? "19px":"",
          paddingRight: isTabletMini && isMainServiceAccordion ? "0.5rem":"",
          backgroundColor : pathName==="/inhome/streamlineordering" && window.location.pathname==="/inhome/streamlinetvvoice" && this.props.buildProductState.router.isAccordionOpen && isMobile ? '#F6F6F6' : 'transparent',
          paddingLeft: streamlineSplOffer || streamLinePhoneTvVoice ? "0px" : "",
        }}
      >
        <div
          style={{height: streamlineSplOffer || streamLinePhoneTvVoice ? "auto" : ""}}
          className={tilebutton}
          id={this.props.name === "toggle_tv_router_accor" ? "focusTvRouter" : this.props.name === "toggle_internet_router_accor" ? "focusInternetRouter" : this.props.name === "toggle_tv_settopbox_accor" ? "focusTvSettopBox" : this.props.name==="toggle_phone_intlcalling_accor" ? "focusPhnIntlCall" : this.props.name==="toggle_phone_winbackcheck_accor" ? "focusWinbackcheck" : this.props.name === "toggle_phone_listing_accor" ? "focusPhnListing" : this.props.name === "toggle_phone_backup_accor" ? "focusPowerReserve" : this.props.name === "toggle_data_splOffer_accor" ? "focusSpecialOffer" : this.props.name === "toggle_tv_CustomTV_accor" ? "focusCustomTv" : this.props.name === "toggle_tv_accor" ? "focusTV" : this.props.name === "toggle_phone_accor" ? "focusPhone" : this.props?.name === "toggle_internet_plan_accor" ? "focusInternetPlan" : "focus2"}
          tabIndex={this.props.isAccordionDisabled ? "-1" : "0"}
          role="button"
          aria-hidden={this.props.isAccordionDisabled}
          aria-expanded={this.props.isAccordionOpen}
          aria-label={this.modifiedTitle()+this.getSubTitleReqString()+this.subTitleReqText(this.props)}
        >
          <div
            className={` ${this.checkIfHoaFlow()?'padding-horiz-zero headline-wrapper hoa-headlineWrapperRskn':'padding-horiz-zero headline-wrapper headlineWrapperRskn'} ${this.props.name === 'toggle_splOffer_accor' || streamlineSplOffer ? "splOfrStreamlineMobile" : ""}`}
          >
            <div
              className={`${"headline-content HdrInternet padding-left-tiny text-black"} ${window.location.pathname==="/inhome/streamlinetvvoice" || isMobile ? "subbAccorStreamlinePaadingBottom" : ""}`}
              id={this.props.id}
            >
              {/* <Title viewport="mobile" primitive="h3" color="black">
              {this.props.title}
            </Title> */}
            <AccordionTitle primitive="h2"><span style={{fontSize: '16px', fontFamily: "Verizon NHG eDS", fontWeight: 700}} className={(this.props.name === "toggle_internet_accor" || this.props.name === "toggle_tv_accor" || this.props.name === "toggle_phone_accor" || this.props.name === 'toggle_contract_accor' || this.props.name === 'toggle_splOffer_accor') ? 'HeaderIcon headerion' : 'HeaderIcon hide'}>
            {this.getAccIcon()}  
            {/* <Icon
            name={this.props.name === "toggle_internet_accor" ? "wifi" : this.props.name === "toggle_tv_accor" ? "tv" : this.props.name === 'toggle_phone_accor' ? 'phone' : this.props.name === 'toggle_contract_accor' ? 'compliance-document' : this.props.name === 'toggle_splOffer_accor' ? "gift": ''}
            size="large" ariaHidden="true"
            />   */}
            
            </span>  
           <span className={"accordionTitle"}>{accordionTitle}</span> </AccordionTitle> 
              <AccordionSubTitleRskn
                {...this.props}
                isAccordionOpen={this.props.isAccordionOpen}
                name={this.props.name}
                RecorderIncluded={this.props.RecorderIncluded}
                selectedProduct={this.props.selectedProduct}
                status={this.props.status}
                subtitle={this.props.subtitle}
                title={this.props.title}
                Voicesubtitle={this.props.Voicesubtitle}
              />
{/* 

            {this.props.buildProduct && this.props.buildProduct.pendingProdNotification && this.props.status === '' &&
            <AccordionSubTitle> <span>{ (this.props.name === 'toggle_phone_plan_accor' && !this.props.buildProduct.isMNEnabled) ? 'Choose your phone plan.': ''}</span></AccordionSubTitle>}
           
              {this.props.buildProduct && this.props.buildProduct.pendingProdNotification && this.props.status === AccordionStatus.required
                && <AccordionSubTitle>
                  
                   
                  <span style={{ color: (this.props.name !== 'toggle_internet_router_accor' && this.props.name !== 'toggle_tv_router_accor') ? '#C44904' : '', paddingRight:'2px' }}>{this.props.name !== 'toggle_internet_router_accor'   ? (this.props.name !== "toggle_tv_router_accor" || this.props.name == "toggle_splOffer_accor" ? 'Required' : 'Choose your router') : ''}</span> 
                 
                  <span>{ this.props.name === 'toggle_tv_settopbox_accor' ? '- Choose your number of TV connections.': this.props.name === 'toggle_splOffer_accor' ? '- Choose one gift, included with your plan.': ''}</span>
                  
                  {this.subTitleReqText(this.props)}
                </AccordionSubTitle>}
              {this.props.selectedProduct && (this.props.selectedProduct.price === 'Included' || (this.props.selectedProduct[0] && this.props.selectedProduct[0].price) === 'Included' || (this.props.RecorderIncluded))
                ? 
                <AccordionSubTitle>
                 
                  {this.props.isMNEnabled
                    ?    (this.props.name === "toggle_tv_recording_accor" ? 'Included -'+this.props.selectedProduct?.name?.replace('4.0', '').replaceAll("&reg;", "\u00AE"): this.props.selectedProduct?.name?.replace('4.0', '').replaceAll("&reg;", "\u00AE") )|| (this.props.name === "toggle_internet_router_accor" ? 'Included -'+this.props.selectedProduct?.accordionTitle?.replace('4.0', '').replaceAll("&reg;", "\u00AE") : 
                    this.props.name === 'toggle_tv_settopbox_accor' && this.checkIfHoaFlow ? this.props.buildProduct.vRoom.unitCount > 1? 'Included - '+ this.props.buildProduct.vRoom.unitCount+ ' Set-top boxes ' :'Included - '+ this.props.buildProduct.vRoom.unitCount+ ' Set-top box' :
                    this.props.selectedProduct?.accordionTitle?.replace('4.0', '').replaceAll("&reg;", "\u00AE") )|| this.props.selectedProduct?.prodName?.replace('4.0', '').replaceAll("&reg;", "\u00AE")
                    : (this.props.name === "toggle_tv_ceapps_accor" ?  'Included - Unlimited' : (this.props.name === 'toggle_tv_settopbox_accor' ? this.checkIfHoaFlow ?  this.props.buildProduct.vRoom.unitCount > 1? 'Included - '+ this.props.buildProduct.vRoom.unitCount+ ' Set-top boxes ' :'Included - '+ this.props.buildProduct.vRoom.unitCount+ ' Set-top box' :'Added '+ this.props.selectedProduct?.prodName : 'Included - ' + this.props.selectedProduct?.prodName ) )
                  }
                </AccordionSubTitle>
                : this.props.status === AccordionStatus.completed
                  ? <AccordionSubTitle> {this.AccTitleaddText(this.props)} </AccordionSubTitle>
                  : this.props.status === AccordionStatus.actionRequired
                    ? <AccordionSubTitle>
                      {!this.props.isMNEnabled && <span style={{ color: '#C44904' }}>Required</span>}
                    </AccordionSubTitle>
                    : 
                    <AccordionSubTitle>
                      {this.props.status === AccordionStatus.added
                        ? (this.props.name === "toggle_phone_intlplans_accor" || this.props.name === "toggle_phone_intlcalling_accor" || this.props.name === 'toggle_phone_winbackcheck_accor' || this.props.name === 'toggle_phone_listing_accor' || this.props.name === 'toggle_phone_backup_accor' || this.props.name === 'toggle_phone_plan_accor' )
                          ? this.subTitleaddText(this.props)
                        //  : this.props.isMNEnabled || !this.props.isMNEnabled
                          //  ? 
                          :  Array.isArray(this.props.selectedProduct) && this.props.selectedProduct.length > 0
                              ? this.props.selectedProduct.map(p => p?.name || p?.accordionTitle || p?.prodName).join(", ")?.replace('4.0', '').replaceAll("&reg;", "\u00AE")
                              : this.props.isAccordionOpen ? this.props.selectedProduct?.name : (this.props.selectedProduct?.accordionTitle !== undefined && this.props.name === "toggle_internet_router_accor") ? 'Included - '+(this.props.selectedProduct?.accordionTitle || this.props.selectedProduct?.name)?.replace('4.0', '').replaceAll("&reg;", "\u00AE")
                              : (this.props.selectedProduct?.accordionTitle !== undefined && this.props.name === "toggle_internet_plan_accor") ?
                                !this.props.isFCPflow ? (this.checkIfHoaFlow?'Included - ':'')+this.props.selectedProduct?.name?.replace('4.0', '').replaceAll("&reg;", "\u00AE") :
                              this.getDataAccTitleOnSelection()
                              : this.props.selectedProduct?.name?.replace('4.0', '').replaceAll("&reg;", "\u00AE") === 'Streaming'
                                ? '1 Gig'
                                : ( (this.props.name === "toggle_tv_recording_accor" || this.props.name === "toggle_internet_router_accor" || this.props.name === "toggle_tv_settopbox_accor" || this.props.name === "toggle_tv_plan_accor")
                                  // Temporary fix - revert (this.props.selectedProduct?.accordionTitle || this.props.selectedProduct?.name) back to this.props.selectedProduct?.accordionTitle once AEM is updated to define accordionTitle for products
                                  ?this.props.name === "toggle_tv_settopbox_accor" && this.checkIfHoaFlow && (this.props.selectedProduct?.name || this.props.selectedProduct?.accordionTitle).toLowerCase().indexOf('fios tv')? this.props.buildProduct.vRoom.unitCount > 1? 'Included - '+ this.props.buildProduct.vRoom.unitCount+ ' Set-top boxes ' :'Included - '+ this.props.buildProduct.vRoom.unitCount+ ' Set-top box' :'Included - '+(this.props.selectedProduct?.accordionTitle || this.props.selectedProduct?.name)?.replace('4.0', '').replaceAll("&reg;", "\u00AE")
                                  : (this.checkIfHoaFlow?'':'')+(this.props.selectedProduct?.accordionTitle ||  (this.props.name === "toggle_data_splOffer_accor") ? (this.props.name === "toggle_tv_router_accor") ? "Added" : ('') : this.props.selectedProduct?.name)?.replace('4.0', '').replaceAll("&reg;", "\u00AE") )
                                  ||  (this.props.selectedProduct?.accordionTitle || this.props.selectedProduct?.name)?.replace('4.0', '').replaceAll("&reg;", "\u00AE")
                                  ||this.props.selectedProduct?.name?.replace('4.0', '').replaceAll("&reg;", "\u00AE")
                            //: (this.props.name === 'toggle_data_splOffer_accor' ? `Included - ${this.props.buildProduct?.sploffer?.selectedProduct?.promoText}` : 'Added')
                        : this.props.status === AccordionStatus.optional
                          ? 
                          (this.props.isMNEnabled == undefined ? this.subTitleOptTextTV(this.props) :  (!this.props.isMNEnabled && !mm3Qualified ?  this.props.subtitle?.replace('4.0', '').replaceAll("&reg;", "\u00AE") : 
                            this.subTitleOptTextTV(this.props)
                          ))
                          : this.props.isMNEnabled && this.props.subtitle?.replace('4.0', '').replaceAll("&reg;", "\u00AE")
                            ? this.props.subtitle?.replace('4.0', '').replaceAll("&reg;", "\u00AE")
                            : (this.props.name === 'toggle_tv_plan_accor' || this.props.name === 'toggle_internet_plan_accor' ? this.subTitleaddText(this.props) : '')
                      }
                      {this.subTitleOptText(this.props)}
                    </AccordionSubTitle>
              }
            <AccordionSubTitle>{(this.props.name == 'toggle_phone_plan_accor' && this.props.status =="") ? '' : ''}</AccordionSubTitle>
            <AccordionSubTitle>{(this.props.name == 'toggle_data_splOffer_accor' && this.props.status ==="added") ? this.props.buildProduct?.sploffer?.selectedProduct?.OfferText : ''}</AccordionSubTitle>
            <AccordionSubTitle>{(this.props.name == 'toggle_internet_perks_accor' && this.props.selectedProduct?.length == 0) ? <span>Optional - Choose your perks.</span> : ''}</AccordionSubTitle>           
*/}
              {promoInfo}
            </div>
          </div>
          <div className="inline-block vert-top text-right right">
            {this.props.title != "No annual contract" && (
              <div className={headerStatusClass} id="internetstatus">
                {actionStatus}
              </div>
            )}
          </div>
        </div>
      </div>
    );

    return <React.Fragment>{template}</React.Fragment>;
  }
}; 
const mapStateToProps = (state) => {
  return {
    buildProduct: state.buildProduct,
    visitId: state.app.visitId,
    cart: state.cart,
    save: state.save,
    flowType: state.app.flowType,
    moveExp: state.moveExp.moveLandingExp,
    isFCPflow: state.loopQual.isFCPflow,
    isDoFlow: state.loopQual.doFlowDetails.isDoFlow,
    zip: state.loopQual.selectedState ? state.loopQual.selectedState.zip : '',
    tarCode: state.loopQual.selectedState ? state.loopQual.lqResponse.tarcode : '',
    cust_opt: state.moveExp.cust_opt,
    isFcpInProfile: state.loopQual.isFcpInProfile,
    lqState: state.loopQual,
    profileCart: state?.profileCart,
    ecProfileCart: state?.ecProfileCart,
  }
}
export default withCookies(connect(
    mapStateToProps,
)(accordionTitleRskn));
